import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelBenchmarkInsightButtonIntercomChecklistSignature {
  Args: {};
}

export default class HotelBenchmarkInsightButtonIntercomChecklist extends Component<HotelBenchmarkInsightButtonIntercomChecklistSignature> {
  @service declare intercom: Services['intercom'];

  @action
  onClick(): void {
    // Intercom checklist: https://app.intercom.com/a/apps/gyngqx5w/outbound/checklists/42797423
    this.intercom.startChecklist('42797423');
  }

  <template>
    <PrismButton
      @buttonType="secondary"
      @label={{t "benchmark_insight.header.need_help"}}
      @onClick={{this.onClick}}
    />
  </template>
}
